import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import type { StudioIdentity } from '../lib/types';

interface AuthWelcomeProps {
  identity: StudioIdentity;
  next: string;
  greeting: string;
}

const HOLD_MS = 1600;

export default function AuthWelcome({ identity, next, greeting }: AuthWelcomeProps) {
  const navigate = useNavigate();
  const [avatarFailed, setAvatarFailed] = useState(false);
  const firstName = identity.name.split(/\s+/)[0] || identity.name;
  const initials = identity.name
    .split(/\s+/)
    .slice(0, 2)
    .map(part => part[0]?.toUpperCase() || '')
    .join('');

  useEffect(() => {
    const timer = window.setTimeout(() => navigate(next, { replace: true }), HOLD_MS);
    return () => window.clearTimeout(timer);
  }, [navigate, next]);

  return (
    <div className="sa-welcome" role="status" aria-live="polite">
      <div className="sa-welcome-avatar">
        <svg viewBox="0 0 100 100" aria-hidden="true">
          <circle cx="50" cy="50" r="47" />
        </svg>
        {identity.avatarUrl && !avatarFailed ? (
          <img src={identity.avatarUrl} alt="" referrerPolicy="no-referrer" onError={() => setAvatarFailed(true)} />
        ) : (
          <span>{initials}</span>
        )}
        <i aria-hidden="true">✓</i>
      </div>
      <span className="sa-mono sa-welcome-eyebrow">Take one · Action</span>
      <h1>
        {greeting}, {firstName}.
      </h1>
      <p className="auth-sub">
        {identity.email}
        <br />
        {identity.studio ? `${identity.studio} · ${identity.role}` : identity.role}
      </p>
      <div className="sa-welcome-bar" aria-hidden="true">
        <i style={{ animationDuration: `${HOLD_MS}ms` }} />
      </div>
      <button type="button" className="sa-link" onClick={() => navigate(next, { replace: true })}>
        Open the studio now →
      </button>
    </div>
  );
}
